import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconRules';
/** Renders an SVG icon. */
const SvgRules = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M26 25a1 1 0 0 1-1 1h-8V6h8a1 1 0 0 1 1 1zm-3.207-11.793a1 1 0 1 0 1.414-1.414L22.914 10.5l1.293-1.293a1 1 0 1 0-1.414-1.414L21.5 9.086l-1.293-1.293a1 1 0 1 0-1.414 1.414l1.293 1.293-1.293 1.293a1 1 0 1 0 1.414 1.414l1.293-1.293zm-13.424-.432a1 1 0 0 0 1.338-.068l3-3a1 1 0 1 0-1.414-1.414L10 10.586l-.793-.793a1 1 0 1 0-1.414 1.414l1.5 1.5zM12 20a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2zm9 0a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2zm-10 4a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2zm12 0a1 1 0 1 0 0-2h-3a1 1 0 1 0 0 2zM6 7a1 1 0 0 1 1-1h8v20H7a1 1 0 0 1-1-1zm22 0a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3z"
      />
    </svg>
  );
};
SvgRules.displayName = displayName;
export default SvgRules;
